import { Reveal } from "./Reveal";

const chapters = [
  {
    number: "01",
    title: "Before skills, we build confidence",
    body: "Every first Odd Hour Lesson starts with a complimentary 30-minute parent & learner chat. We put mums and dads at ease, understand your goals and concerns, and create a plan built around the learner — not just the licence.",
  },
  {
    number: "02",
    title: "Quiet roads first",
    body: "We start on quiet roads with less traffic and fewer distractions. As confidence grows, we gradually build up to busier times — so peak hour doesn't feel so scary.",
  },
  {
    number: "03",
    title: "Experience before the experience happens",
    body: "Flat tyres. Fatigue. Overheating engines. Safe decisions when nobody is sitting beside you. We teach practical vehicle knowledge and real-life judgement — so nothing on the road is ever a first.",
  },
];

export default function Manifesto() {
  return (
    <section id="why-us" className="px-6 md:px-12 py-24 md:py-32 max-w-[1600px] mx-auto">
      <Reveal>
        <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#F5B301] mb-6">02 — Why We Exist</p>
        <h2 className="font-cabinet font-black uppercase tracking-tighter text-4xl md:text-6xl leading-[0.95] text-[#f5f5f0]">
          Every parent wants <span className="text-[#F5B301]">the same thing.</span>
        </h2>
        <p className="font-script text-2xl md:text-3xl text-white/60 mt-6 -rotate-1">For their son or daughter to come home safely.</p>
      </Reveal>

      <div className="mt-8">
        {chapters.map((chapter, i) => (
          <Reveal key={chapter.number} delay={0.05}>
            <div
              data-testid={`manifesto-chapter-${chapter.number}`}
              className="grid md:grid-cols-12 gap-6 md:gap-12 items-center border-t border-white/10 py-16 md:py-24"
            >
              <div className={`md:col-span-5 ${i % 2 === 1 ? "md:order-2 md:text-right" : ""}`}>
                <span className="font-cabinet font-black text-[7rem] md:text-[11rem] leading-none text-outline select-none">
                  {chapter.number}
                </span>
              </div>
              <div className={`md:col-span-7 ${i % 2 === 1 ? "md:order-1" : ""}`}>
                <h3 className="font-cabinet font-black uppercase tracking-tighter text-3xl md:text-5xl leading-none text-[#f5f5f0]">
                  {chapter.title}
                </h3>
                <p className="text-base md:text-lg text-white/60 leading-relaxed mt-6 max-w-xl">{chapter.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
